<template>
  <div>
    <el-button type="primary" size="small" @click="appointAuth()">指定认证</el-button>
  </div>
</template>

<script>
import Dialog from "@/assets/js/dialog";
import AppointAuthDialog from "@/components/resume/AppointAuthDialog";

export default {
  name: "AppointAuth",
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      rowData: this.row
    }
  },
  watch: {
    row() {
      this.rowData = this.row
    }
  },
  methods: {
    // 指定认证
    appointAuth() {
      // console.log(this.rowData)
      Dialog.open({
        title: '指定用户【'+ this.rowData.nickName +'】去认证？',
        component: AppointAuthDialog,
        data: {
          identity: this.rowData.recheckAuthIdentity,
          zhima: this.rowData.recheckAuthZhima,
          video: this.rowData.recheckAuthVideo,
          identityState: this.rowData.identityAuth.identityState,
          baiduState: this.rowData.identityAuth.baiduState,
          zhimaCertifyState: this.rowData.identityAuth.zhimaState,
          videoState: this.rowData.authVideo?this.rowData.authVideo.state:'',
          cancelVideoAuth: this.rowData.cancelVideoAuth,
          cancelIdentityAuth: this.rowData.cancelIdentityAuth,
          cancelZhimaAuth: this.rowData.cancelZhimaAuth,
          userId: this.userId?this.userId:this.rowData.userId,
          width: '400px'
        },
        confirm: (result) => {
          if(result.type == 1) {
            this.rowData.cancelIdentityAuth = result.state;
          } else if(result.type == 2) {
            this.rowData.cancelZhimaAuth = result.state;
          } else if(result.type == 3) {
            this.rowData.cancelVideoAuth = result.state;
          } else {
            this.rowData.recheckAuthIdentity = result.recheckAuthIdentity;
            this.rowData.recheckAuthZhima = result.recheckAuthZhima;
            this.rowData.recheckAuthVideo = result.recheckAuthVideo;
          }
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
